module.exports = __webpack_public_path__ + "img/glasbreak-sensor-lg-bad.42340b25.svg";